
import * as React from 'react';
import { useMemo, useState } from "react";
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { epochToDateTime } from "../../../shared/functions/toDateTime";
import useToggle from "../../../shared/functions/useToggle";
import { LoadingButton } from "@mui/lab";
import { FormikProvider, useFormik } from "formik";
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import {
    Grid,
    MenuItem,
    Checkbox,
    TextField,
    FormControlLabel, Button, Stack, Typography, Backdrop, CircularProgress,
} from "@mui/material";
// import { isArray, isEmpty, isUndefined, values, keys, uniq } from "lodash";
import { CenterContainer, FormContainer, ReturnButton } from 'src/components/items/fragments/_styled_components';
import ImagesSelection from "src/components/items/fragments/ImagesSelection";
import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
// import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function POEdit({ open, onClose, data }) {
    const isEdit = Boolean(data);
    const [isLoading, setIsLoading] = useState(false)
    const { handleOpen } = useToggle({});
    const navigation = useHistory();
    // const shouldBeLoading = useMemo(() => loading  )

    const [showPassword, setShowPassword] = React.useState(false);

    // const handleClickShowPassword = () => setShowPassword((show) => !show);

    // const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     event.preventDefault();
    // };

    console.log(JSON.stringify(data))

    const handleClose = () => onClose && onClose()

    const priceFormat = /^[0-9]\d*(\.\d+)?$/

    const schema = Yup.object().shape({
        Name: Yup.string().required('Le nom est requis'),
        Price: Yup.number().required('Le Prix est requis'),
        UPC: Yup.number().required('Le UPC est requis'),
        InternalId: Yup.string().required('Le InternalId est requis'),
        SellPrice: Yup.string().matches(priceFormat, "Le Prix saisi est invalide").required('Le Prix achat est requis'),
        Discount: Yup.string().matches(priceFormat, "Le Prix saisi est invalide").required('Le  Prix de vente est requis'),
        Amount: Yup.string().matches(priceFormat, "Le Prix saisi est invalide").required('Le  Prix de vente est requis'),
        ShippedQuantity: Yup.string().matches(priceFormat, "Le Prix saisi est invalide").required('Le  Prix de vente est requis'),
        Quantity: Yup.string().matches(priceFormat, "Le Prix saisi est invalide").required('Le  Prix de vente est requis'),
    });

    const formik = useFormik({
        initialValues: {
            Name: data[0].name,
            Price: data[0].price,
            UPC: data[0].barcode,
            InternalId: data[0].proSoftId,
            SellPrice: data[0].sellPrice,
            Discount: data[0].discount,
            Amount: data[0].amount,
            ShippedQuantity: data[0].shippedQuantity,
            Quantity: data[0].quantity,
            Received: data[0].isReceived,
            ExpirationDate: data[0].expires,
        },
        validationSchema: schema,
        onSubmit: values => {
            console.log(JSON.stringify(values));
        },
    });


    const {
        values,
        errors,
        touched,
        handleSubmit,
        getFieldProps,
        setFieldValue,
        isSubmitting
    } = formik;


    // const handleBack = () => navigation.goBack();

    // const handleDrop = (files) => setFieldValue('_files', uniq([...values._files, ...files]))

    // const handleRemove = (preview) => {
    //     setFieldValue('_files', values._files.filter(one => one.preview !== preview))
    // }

    // const handleRemoveAll = () => setFieldValue('_files', [])



    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Close
                    </Typography>
                    <Button autoFocus color="inherit" onClick={handleClose}>
                        Save
                    </Button>
                </Toolbar>
            </AppBar>

            {/* <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <div>
                    <TextField
                        label="With normal TextField"
                        id="outlined-start-adornment"
                        sx={{ m: 1, width: '25ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
                        }}
                    />
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-weight"
                            endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                        />
                        <FormHelperText id="outlined-weight-helper-text">Weight</FormHelperText>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }}>
                        <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            label="Amount"
                        />
                    </FormControl>
                </div>
                <div>
                    <TextField
                        label="With normal TextField"
                        id="filled-start-adornment"
                        sx={{ m: 1, width: '25ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
                        }}
                        variant="filled"
                    />
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="filled">
                        <FilledInput
                            id="filled-adornment-weight"
                            endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                            aria-describedby="filled-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                        />
                        <FormHelperText id="filled-weight-helper-text">Weight</FormHelperText>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="filled">
                        <InputLabel htmlFor="filled-adornment-password">Password</InputLabel>
                        <FilledInput
                            id="filled-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="filled">
                        <InputLabel htmlFor="filled-adornment-amount">Amount</InputLabel>
                        <FilledInput
                            id="filled-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        />
                    </FormControl>
                </div>
                <div>
                    <TextField
                        label="With normal TextField"
                        id="standard-start-adornment"
                        sx={{ m: 1, width: '25ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
                        }}
                        variant="standard"
                    />
                    <FormControl variant="standard" sx={{ m: 1, mt: 3, width: '25ch' }}>
                        <Input
                            id="standard-adornment-weight"
                            endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                            aria-describedby="standard-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                        />
                        <FormHelperText id="standard-weight-helper-text">Weight</FormHelperText>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                        <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                        <Input
                            id="standard-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>
                        <Input
                            id="standard-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        />
                    </FormControl>
                </div>
            </Box> */}

<FormikProvider value={formik}>
    <FormContainer autoComplete='off' noValidate autoCapitalize='on' onSubmit={handleSubmit}>

        <Grid container spacing={3}>

            {/* <Grid xs={12} item md={6}>
                            <CenterContainer>
                                <ImagesSelection
                                    files={values._files}
                                    onDrop={handleDrop}
                                    onRemove={handleRemove}
                                    onRemoveAll={handleRemoveAll}
                                />
                            </CenterContainer>


                        </Grid> */}

            <Grid item md={6}>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label='Nom du produit'
                            variant={"outlined"}
                            error={Boolean(touched.Name && errors.Name)}
                            helperText={touched.Name && errors.Name}
                            {...getFieldProps('Name')}
                        />
                    </Grid>


                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Reference Pro Soft'
                            variant={"outlined"}
                            error={Boolean(touched.InternalId && errors.InternalId)}
                            helperText={touched.InternalId && errors.InternalId}
                            {...getFieldProps('InternalId')}
                        />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='UPC ou Barcode'
                            variant={"outlined"}
                            error={Boolean(touched.UPC && errors.UPC)}
                            helperText={touched.UPC && errors.UPC}
                            {...getFieldProps('UPC')}
                        />
                    </Grid>


                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Prix d achat'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.Price && errors.Price)}
                            helperText={touched.Price && errors.Price}
                            {...getFieldProps('Price')}
                        />
                    </Grid>




                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label="Quantité"
                            type="number"
                            variant={"outlined"}
                            error={Boolean(touched.Quantity && errors.Quantity)}
                            helperText={touched.Quantity && errors.Quantity}
                            {...getFieldProps('Quantity')}
                        />
                    </Grid>



                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Shipped Quantity'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.ShippedQuantity && errors.ShippedQuantity)}
                            helperText={touched.ShippedQuantity && errors.ShippedQuantity}
                            {...getFieldProps('ShippedQuantity')}
                        />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Disc'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.Discount && errors.Discount)}
                            helperText={touched.Discount && errors.Discount}
                            {...getFieldProps('Discount')}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Amount'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.Amount && errors.Amount)}
                            helperText={touched.Amount && errors.Amount}
                            {...getFieldProps('Amount')}
                        />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Recv'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.Received && errors.Received)}
                            helperText={touched.Received && errors.Received}
                            {...getFieldProps('Received')}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Sell Price'
                            variant={"outlined"}
                            type="number"
                            error={Boolean(touched.SellPrice && errors.SellPrice)}
                            helperText={touched.SellPrice && errors.SellPrice}
                            {...getFieldProps('SellPrice')}
                        />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            label='Expires'
                            variant={"outlined"}
                            type="date"
                            error={Boolean(touched.ExpirationDate && errors.ExpirationDate)}
                            helperText={touched.ExpirationDate && errors.ExpirationDate}
                            {...getFieldProps('ExpirationDate')}
                        />
                    </Grid>

                </Grid>

            </Grid>


            <Grid item xs={12}>
                <CenterContainer>
                    <LoadingButton
                        type={"submit"}
                        variant={"contained"}
                        color={"primary"}
                        loading={isLoading}
                        disabled={isSubmitting}
                        fullWidth
                        sx={{ width: 400 }}
                    >
                        Enregistrer
                    </LoadingButton>
                </CenterContainer>
            </Grid>

        </Grid>
        ²

    </FormContainer>

</FormikProvider>


        </Dialog>
    )
}
